import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "3D slike",
  "description": "",
  "published": "2007-01-25T00:00:00.000Z",
  "redirect_from": ["/blog/3d-slike/swizec/306"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pred kratkim mi je nekdo pokazal `}<a parentName="p" {...{
        "href": "http://hof.povray.org/"
      }}>{`tole stran`}</a>{`, polno izjemnih racunalniskih 3D slik; verjetno najboljsih, kar sem jih kdaj imel zadovoljstvo videti.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      